import React, { useContext, useMemo, useEffect } from 'react';
import { useParams } from 'react-router-dom';

import './styles.scss';
import { RacingsContext } from '@racings/store/context';
import { useDataFetch } from '@common/hooks/dataFetch';
import { swarmRequest } from '@common/helpers/util/requestMiddleware';
import { SportTypesIds, SportTypesUrlIds } from '@racings/constants/enums/sportTypes';
import { RacingResultGame } from './racingResultRacingGame';
import { RacingResultDetailsTimeFilter } from './racingResultDetailsTimeFilter';
import { ResultDetailsHeader } from './resulDetailHeader';
import { listFilter, racingsListGroupedFromResults } from '../helper/resultSelector';
import { useOutletContext } from 'react-router';

const RacingResultDetails = ({ routePrefix = "" }) => {
  const [{
    dateFilter, resultData, isYesterday,
  }, setRacingsState] = useContext(RacingsContext);
  const {
    sportType, gameId: activeGameId, compId, matchId, regionAlias,
  } = useParams();
  const [searchText] = useOutletContext();

  const activeSportId = SportTypesUrlIds[sportType] || SportTypesIds.HORSE;

  const reqData = useMemo(() => ({
    is_yesterday: isYesterday,
    sport_id: activeSportId,
  }), [activeSportId, isYesterday]);

  const matchReq = {
    match_id: matchId,
  };

  const [matchData] = useDataFetch(() => swarmRequest(matchReq, 'get_winner_market'), [matchId]);

  const matches = matchData?.details ?? [];

  const [_data] = useDataFetch(() => (!resultData[isYesterday ? 'yesterday' : 'today'] ? swarmRequest(reqData, 'get_racing_matches') : null), [reqData, resultData, isYesterday]);

  const data = resultData || _data;

  const results = resultData[isYesterday ? 'yesterday' : 'today']?.details || data?.details;

  const groupedData = useMemo(() => racingsListGroupedFromResults(results), [activeSportId, dateFilter, results]);

  const racingsResultListFiltered = useMemo(() => listFilter(searchText, regionAlias, groupedData), [searchText, groupedData, regionAlias, dateFilter]);

  useEffect(() => {
    if (_data) {
      setRacingsState((old) => ({
        ...old,
        resultData: { ...old.resultData, [isYesterday ? 'yesterday' : 'today']: _data },
      }));
    }
    return () => {
      if (!_data) {
        return null;
      }
    };
  }, [_data, isYesterday, setRacingsState]);

  const competition = racingsResultListFiltered[0]?.competitions?.filter((item) => item.id === +compId);

  return (
    <div className="racing-details-container">
      <ResultDetailsHeader
        gameList={competition}
        competitionName={competition}
        routePrefix={routePrefix}
      />
      <div className="time-filter-wrapper">
        {competition
          && (
            <RacingResultDetailsTimeFilter
              routePrefix={routePrefix}
              competitionGames={competition[0]}
            />
          )}
      </div>
      <div className="games-list">
        {matches && (
          <RacingResultGame
            key={matches.MatchId}
            game={{
              id: matches.MatchId,
              start_ts: matches.StartTime,
              region_alias: regionAlias,
              market: matches,
            }}
            activeGameId={activeGameId}
            competitionName={matches.MarketName}
          />
        )}
      </div>
    </div>
  );
};

export default RacingResultDetails;
